var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 433.7 433.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #231f20;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 433.7,
    height: 433.7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M216.9,433.7c119.8,0,216.9-97.1,216.9-216.9S336.6,0,216.9,0,0,97.1,0,216.9s97.1,216.9,216.9,216.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M331.4,282.6h51.9v-19.5h-30v-9.4h27v-17.7h-27v-9.1h30v-19.5h-51.9v75.1ZM324.7,207.4h-20.8v39.6h-.1l-27.1-39.6h-20.9v75.1h20.8v-40.3h.1l27.1,40.3h20.9v-75.1ZM172.8,239.4c0,23.2,17.5,39.5,39.9,39.5s39.9-16.3,39.9-39.5-17.4-39.4-39.9-39.4-39.9,16.2-39.9,39.4M212.8,259c-9.2,0-17.8-7-17.8-19.6s8.6-19.5,17.8-19.5,17.8,7,17.8,19.5-8.8,19.6-17.8,19.6M124.6,282.6h51.4v-19.8h-29.5v-55.3h-21.9v75.1ZM78.4,250.2l6.6-20.5,6.7,20.5h-13.4ZM125.4,282.6l-27.6-75.1h-25.4l-27.1,75.1h22.7l4.7-14.8h24.8l4.9,14.8h22.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M282.5,201.6h21.9v-55.3h20.6v-19.8h-63.3v19.8h20.7v55.3ZM185.1,169.6c0,23.2,17.5,39.5,39.9,39.5s39.9-16.3,39.9-39.5-17.4-39.4-39.9-39.4-39.9,16.2-39.9,39.4M225,189.2c-9.2,0-17.8-7-17.8-19.6s8.6-19.5,17.8-19.5,17.8,7,17.8,19.5-8.8,19.6-17.8,19.6M182.2,126.5h-20.8v39.6h0l-27.1-39.6h-20.9v75.1h20.8v-40.3h.1l27.1,40.3h20.9v-75.1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ab67d451af1d3657c1d7a8a15ee5fd18.svg";
export { ForwardRef as ReactComponent };